


















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
})

export default class IntradorLoader extends Vue {
  @Prop(Number) protected isLoading!: number;
}
